import { render, staticRenderFns } from "./client-equipment-list-new-tab.vue?vue&type=template&id=4462a8ec"
import script from "./client-equipment-list-new-tab.vue?vue&type=script&lang=js"
export * from "./client-equipment-list-new-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports